import React from "react";
import Card from "react-bootstrap/Card";
import {
  RiRocket2Line,
  RiCpuLine,
  RiLightbulbFlashLine,
} from "react-icons/ri";

const roleSections = [
  {
    id: "founder",
    title: "As a Founder",
    icon: <RiRocket2Line />,
    accent: "#ff8a57",
    glow: "rgba(255, 138, 87, 0.25)",
    paragraphs: [
      "I am currently building CareerMojo, a credibility-first early-career opportunity matchmaking platform focused on helping people make sharper decisions while giving startups richer signals beyond resumes.",
      "I’m actively onboarding the first users and partnering with recruiters and founding teams, prioritizing insights that only show up through real usage.",
      "My founder journey is rooted in rapid experimentation, tight feedback loops, and building systems that solve the most pressing problems for job-seekers and recruiting managers alike.",
    ],
  },
  {
    id: "engineer",
    title: "As an Engineer",
    icon: <RiCpuLine />,
    accent: "#b5c6ff",
    glow: "rgba(181, 198, 255, 0.3)",
    paragraphs: [
      "I design and build end-to-end machine learning systems—data collection, analysis, modeling, evaluation, deployment, and monitoring all the way through.",
      "I’ve led initiatives from initial product scoping to production deployments, moving across backend services, ML infrastructure, and experimentation workflows without dropping context.",
      "Reproducibility, clean system design, and eval-driven development guide my engineering practice, and I’m comfortable debugging both data quirks and systems failures in production environments.",
    ],
  },
  {
    id: "solver",
    title: "As a Problem Solver",
    icon: <RiLightbulbFlashLine />,
    accent: "#ffd479",
    glow: "rgba(255, 212, 121, 0.25)",
    paragraphs: [
      "I’m drawn to high-impact, real-world problems where data and AI can directly improve how systems serve people.",
      "Trustworthy information systems, institutional trust, and responsible AI deployment anchor the way I pick projects.",
      "I’m especially keen on personalized learning (true personalization isn’t solved yet) and on applying AI to urban infrastructure, planning, and disaster management—domains where predictive and decision-support systems have tangible societal impact.",
    ],
  },
];

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <div className="role-grid">
            {roleSections.map((section) => (
              <div
                key={section.id}
                className="role-panel"
                style={{
                  "--role-accent": section.accent,
                  "--role-glow": section.glow,
                }}
              >
                <div className="role-chip">
                  <span className="role-icon">{section.icon}</span>
                  <span>{section.title}</span>
                </div>
                <div className="role-body">
                  {section.paragraphs.map((text, index) => (
                    <p key={`${section.id}-p-${index}`}>{text}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
